<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						<!-- <el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item> -->
						
						<!-- <el-form-item :label="$t('acapplyList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('acapplyList.dai')" :value="0"></el-option>
								<el-option :label="$t('acapplyList.yes')" :value="1"></el-option>
								<el-option :label="$t('acapplyList.no')" :value="2"></el-option>
								<el-option :label="$t('acapplyList.close')" :value="3"></el-option>
								
							</el-select>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('monList.mon')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="month"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('orderList.addOrder')}}</el-button>
						
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" @expand-change="openTable">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column  align="center" type="index"  :label="$t('adminList.sort')" width="60">
				</el-table-column>
				
				<el-table-column  type="expand" :label="$t('status.log')">
				     <template slot-scope="props">
				       <el-table @expand-change="openTable2" v-loading="props.row.load" class="noth" stripe  :data="props.row.data" style="width: 100%;padding-left: 60px;" >
						   
						   <el-table-column  type="expand" :label="$t('status.log')">
							   <template slot-scope="props2">
								   <el-table  v-loading="props2.row.load" class="noth" stripe  :data="props2.row.data" @expand-change="openTable3" style="width: 100%;" >
									   
								<el-table-column  type="expand" :label="$t('status.log')">
									   	<template slot-scope="props3">
									   		<el-table  v-loading="props3.row.load" class="noth" stripe  :data="props3.row.data" style="width: 100%;padding-left: 48px;" >
									   			<!-- 第四层数据 -->
									   			
									   			<el-table-column align="center" width="120" prop="user_name" :label="$t('orderList.user')">								   													
												<template slot-scope="scope">
													<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
													
												</template>
									   			</el-table-column>
												
												
												<el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
													<template slot-scope="scope">
														{{ props.row.date }}
													  </template>
												</el-table-column>
												
												
												<el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
													<template slot-scope="scope">
														{{ props2.row.cloud_name }}
													  </template>
												</el-table-column>
												
												
												<el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
													<template slot-scope="scope">
														{{ props3.row.username }}
														
													</template>
												</el-table-column>
												
												<el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
												</el-table-column>
												
												
												
												<el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
													
												
												</el-table-column>
												
												<el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
												</el-table-column>
												
												
												<el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
													
												
												</el-table-column>
												
												
												
												<el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
													<template slot-scope="scope">
														<span class="text_chengse">{{scope.row.need_money}}</span>
													</template>
												</el-table-column>
									   		</el-table>
									   	</template>
									   </el-table-column>
									   
									   <!-- 第三层数据 -->
									   
									   <el-table-column align="center" width="120" prop="user_name" :label="$t('orderList.user')">
										   
										
										<template slot-scope="scope">
											<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
											
										</template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
										<template slot-scope="scope">
											{{ props.row.date }}
										  </template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
									   	<template slot-scope="scope">
									   		{{ scope.row.cloud_name }}
									   	  </template>
									   </el-table-column>
									   
									   
									   <el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
									   	<template slot-scope="scope">
									   		{{ scope.row.username }}
									   		
									   	</template>
									   </el-table-column>
									   
									   
									   <el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
									   	<template slot-scope="scope">
									   		<span>{{$t('status.all')}}</span>
									   		
									   	</template>
									   </el-table-column>
									   
									   
									   
									   <el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
									   	
									   
									   </el-table-column>
									   
									   
									   <el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
									   </el-table-column>
									   
									   
									   <el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
									   	
									   
									   </el-table-column>
									   
									   
									   
									   <el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
									   	<template slot-scope="scope">
									   		<span class="text_chengse">{{scope.row.need_money}}</span>
									   	</template>
									   </el-table-column>
									   
									   
								   </el-table>
							   </template>
						   </el-table-column>
						   <!-- 第二层数据 -->
						   
						   <el-table-column align="center" width="120" prop="user_name" :label="$t('orderList.user')">
						   	<template slot-scope="scope">
						   		<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   <el-table-column align="center" width="100" prop="date" :label="$t('orderList.date')">
						   	<template slot-scope="scope">
						   		{{ props.row.date }}
						   	  </template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
						   	<template slot-scope="scope">
						   		{{ scope.row.cloud_name }}
						   	  </template>
						   </el-table-column>
						   
						   
						   <el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   <el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
						   	<template slot-scope="scope">
						   		<span>{{$t('status.all')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   
						   
						   
						   <el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
						   	
						   
						   </el-table-column>
						   
						   
						   
						   
						   <el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
						   </el-table-column>
						   
						   
						   <el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
						   	
						   
						   </el-table-column>
						   
						   
						   
						   <el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
						   	<template slot-scope="scope">
						   		<span class="text_chengse">{{scope.row.need_money}}</span>
						   	</template>
						   </el-table-column>
						   
						   
						   
						   <el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
						   	<template slot-scope="scope">
						   		<span class="text-success"  v-if="props.row.is_ok==1">{{$t('monList.yes')}}</span>
						   		<span style="color: #999;"  v-if="props.row.is_ok==0">{{$t('monList.no')}}</span>
						   		
						   	</template>
						   </el-table-column>
						   			
						   
						   
						   		
						   <el-table-column width="180"  prop="id" align="center" :label="$t('adminList.operation')">
						   	<template slot-scope="scope">
						   		<el-button-group>
						   			<el-button :disabled="layout.loading" :loading="layout.loading"  @click="printPdf(props.row,scope.row.cloud_id)"  size="mini" plain type="success">{{$t('monList.down')}}</el-button>
						   			
						   			<!-- <el-button :disabled="layout.loading || scope.row.is_ok==1 || scope.row.is_now_mon==1" :loading="layout.loading"  @click="confirmOrder(scope.row.id)"  size="mini" plain type="warning">{{$t('monList.confirmOrder')}}</el-button> -->
						   		</el-button-group>
						   	</template>
						   </el-table-column>
											
							
							
						
				       	
		
				     
				
				       </el-table>
				     </template>
				   </el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				
				
				<el-table-column align="center" width="120" prop="user_name" :label="$t('monList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="date" :label="$t('monList.date')">
				</el-table-column>
				
				
				<el-table-column width="120" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center" width="160" prop="username" :label="$t('model.yunAccount')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				
				<el-table-column width="120" align="center" prop="pro_name" :label="$t('orderList.product')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				
				
			<el-table-column  width="120" align="center" prop="order_money" :label="$t('orderList.order_money')">
				
			
			</el-table-column>
				
				
				<el-table-column align="center" width="120"  prop="total" :label="$t('dayList.total_money')">
				</el-table-column>
				
				
				<el-table-column  width="120" align="center" prop="odds_money" :label="$t('orderList.odds_money')">
					
				
				</el-table-column>
				

				
				<el-table-column align="center"  width="120"  prop="need_money" :label="$t('monList.need_money')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.need_money}}</span>
					</template>
				</el-table-column>
				
				
				
				<el-table-column align="center"  width="120"  prop="is_ok" :label="$t('monList.confirmOrder')">
					<template slot-scope="scope">
						<span class="text-success"  v-if="scope.row.is_ok==1">{{$t('monList.yes')}}</span>
						<span style="color: #999;"  v-if="scope.row.is_ok==0">{{$t('monList.no')}}</span>
						
					</template>
				</el-table-column>
			
				
				
		
				<el-table-column width="180"  prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button :disabled="layout.loading" :loading="layout.loading"  @click="printPdf(scope.row)"  size="mini" plain type="success">{{$t('monList.down')}}</el-button>
							
							<el-button :disabled="layout.loading || scope.row.is_ok==1 || scope.row.is_now_mon==1" :loading="layout.loading"  @click="confirmOrder(scope.row.id)"  size="mini" plain type="warning">{{$t('monList.confirmOrder')}}</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('orderList.editOrder') : $t('orderList.addOrder')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('orderList.OrderType')">
					<el-radio-group v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('orderList.OrderType1')}}</el-radio>
						<el-radio :disabled="true" :label="2" border>{{$t('orderList.OrderType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				
				<el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud" :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item v-loading="layout.loading" v-if="form.cloud_id" :label="$t('model.yunAccount')" prop="account_id">
					<el-select @change="changeAccount" style="width: 85%;"  :disabled="editIndex > -1" v-model="form.account_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
			
				
				
			
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				
				
				
				<el-form-item :label="$t('orderList.product')" prop="product_id">
					<el-select @change="selProduct" v-model="form.product_id" size="small" filterable :placeholder="$t('system.select')">
					
					</el-option>
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item  :label="$t('orderList.logType')">
					<el-radio-group v-model="form.log_type" size="small">
						<el-radio :label="1" border>{{$t('orderList.logType1')}}</el-radio>
						<el-radio :label="2" border>{{$t('orderList.logType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				<el-form-item  :label="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" prop="money">
					<el-input v-model="form.money" type="number" :placeholder="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				<el-form-item v-if="form.log_type==1"  :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
			
				
				<el-form-item  :label="$t('orderList.date')" prop="date">
					 <el-date-picker
					      v-model="form.date"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  format="yyyy-MM-dd"
					      type="date"
					      :placeholder="$t('orderList.selDate')">
					    </el-date-picker>
				</el-form-item>
				
				<el-form-item  :label="$t('orderList.use_num')" prop="use_num">
					<el-input v-model="form.use_num" type="number" :placeholder="$t('orderList.use_num')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item  :label="$t('orderList.order_no')" prop="order_no">
					<el-input v-model="form.order_no" :placeholder="$t('orderList.order_no')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			
				
				
				<el-form-item :label="$t('orderList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					time:[],
				},
				auth_val: 'Admin',

				preUrl: "data/monList", //列表地址
				delAllUrl: "data/delAccountApplyAll", //批量删除地址
				delUrl: "data/delAccountApply", //删除單条地址
				addUrl: "data/addOrder", //添加/修改地址
				editStatusUrl:"data/editStatusAccountApply",//修改狀態地址
				agentData:[],
				tableData: [],
				account:[],
				form: {},
				rules: {
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					money: [{
						required: true,
						message: this.$t('orderList.inpMoney'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
					product_id: [{
						required: true,
						message: this.$t('orderList.selProduct'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('account');
		},
		methods: {
			selProduct(e){
				// console.log(e)
				// let index = this.agentData.product.findIndex(item=>item.id==e)
				// console.log(this.agentData.product[index])
				// if(index != -1){
				// 	this.is_odds = this.agentData.product[index].is_odds
				// }else{
				// 	this.is_odds = 1;
				// }
			},
			changeAccount(e){
				let index = this.account.findIndex(item=>item.id==e)
				this.form.odds = this.account[index].odds
			},
			changeCloud(e){
				console.log(e)
				this.form.account_id = ''
				this.commonList('orderAccount',e);
			},
			openTable(row){
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						type:1
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			openTable2(row){
				
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						cloud_id:row.cloud_id,
						type:2
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						//console.log(list)
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			
			openTable3(row){
				console.log(row)
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/monDetail', {
						uid:row.uid,
						date:row.date,
						account_id:row.account_id,
						need_money:row.need_money,
						total:row.total,
						type:3
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						console.log(list)
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
			},
			
			
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 2
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				// 增加
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						order_no:'',
						id:0,
						type: 1,
						cloud_id: '',
						account_id:'',
						product_id:'',
						odds:'',
						log_type:1,
						use_num:'',
						money:'',
						date:date,
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						log_type: e.log_type,
						use_num: e.use_num,
						product_id: e.product_id,
						status: e.status,
						money:e.money,
						money_type:e.money_type,
						remark:e.remark
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			
			printPdf(row,cloud_id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/data/printPdf', {
					id: row.id,
					cloud_id:cloud_id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.layout.loading = false;
					console.log(list)
					
					const link = document.createElement('a');
					link.href = list;
					link.download = ''; // 留空会自动用原文件名，也可以写 '報表.pdf'
					link.target = '_blank'; // 避免弹窗拦截
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			confirmOrder(id){
				this.$confirm(this.$t('monList.is_ok_title'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					let url = '/admin/data/confirmOrder'
					this.axios.post(url, {
						id: id,
					}, {
						token: true,
						loading: true
					}).then(res => {
				
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
						this.getList()
						//this.layout.getPageNum()
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			//公共列表
			commonList(type,id=0) {
				this.account = [];
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type=='account'){
						this.agentData = list
					}else{
						//console.log(list)
						this.account = list.account
					}
					

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					cloud_id:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

::v-deep(.el-table__expanded-cell) {
  overflow: visible !important;
  padding: 12px 20px !important;
}

.expand-wrapper {
  display: block;
  width: 100%;
  padding-left: 60px;
  box-sizing: border-box;
}

</style>
